import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import styles from './styles.module.scss'

export default function DeleteFileConfirmation({ fileName, deleteFileLoading, handleDelete, handleClose }) {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <h1
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: t('global.deleteFileConfirmation', fileName ? { filename: fileName.name } : ''),
        }}></h1>
      <div className={styles.buttonWrapper}>
        <Button size='large' text={t('messenger.btnCancel')} style='tertiary' handleClick={handleClose} />
        <Button
          size='large'
          text={deleteFileLoading ? <Spinner customCss={styles.spinner} isWhite={true} /> : t('messenger.btnDoIt')}
          handleClick={handleDelete}
        />
      </div>
    </div>
  )
}
